export default __webpack_public_path__ + "static/media/veh-10.58cba04d.png";